const TIME_PREFIX = '_expire_at_'
const AN_HOUR = 60
const TIME_OPTIONS: Record<string, number> = {
  day: 24 * AN_HOUR,
  halfday: 12 * AN_HOUR,
  hour: AN_HOUR,
  halfhour: 0.5 * AN_HOUR,
  fiveminutes: 5,
}

const getPrefixedParam = (param: string) => String(param + TIME_PREFIX)

const clearValues = (param: string): void => {
  try {
    localStorage.removeItem(String(param))
    localStorage.removeItem(getPrefixedParam(param))
  } catch (err) {
    console.warn('Error deleting the local storage', err)
  }
}

const getValue = (param: string): unknown => {
  const expire = localStorage.getItem(getPrefixedParam(param))
  if (!expire) {
    clearValues(param)
    return null
  }

  if (Number(expire) < new Date().getTime()) {
    clearValues(param)
    return null
  }

  const rawValue = localStorage.getItem(String(param))
  if (!rawValue) {
    clearValues(param)
    return null
  }

  try {
    return JSON.parse(rawValue)
  } catch (err) {
    clearValues(param)
    console.error('Error getting the local storage', err)
    return null
  }
}

const setValue = (name: string, value: unknown, expireAt?: Date | string): unknown => {
  clearValues(name)

  try {
    let timeStamp: number
    if (expireAt instanceof Date) {
      timeStamp = expireAt.getTime()
    } else {
      let minutes = AN_HOUR
      if (expireAt && typeof TIME_OPTIONS[expireAt] === 'number') {
        minutes = TIME_OPTIONS[expireAt]
      }
      timeStamp = new Date().getTime() + minutes * 60 * 1000
    }

    const stringifyValue = JSON.stringify(value)
    if (stringifyValue === undefined) throw new Error("I can't store that")

    localStorage.setItem(String(name), stringifyValue)
    localStorage.setItem(getPrefixedParam(name), String(timeStamp))
    return value
  } catch (err) {
    console.warn('Error setting the local storage', err)
    throw new Error('Error storing the value ' + err)
  }
}

const sCache = { set: setValue, get: getValue, clear: clearValues }

export default sCache
